// extracted by mini-css-extract-plugin
export default {"title":"MasterSaleDetails_title__O19i2","total":"MasterSaleDetails_total__GM6Qq","edit":"MasterSaleDetails_edit__84x5y","cancel":"MasterSaleDetails_cancel__VrM-6"};